import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import head from 'lodash.head';
import get from 'lodash.get';
import Spinner from '../../components/spinner/Spinner';
import DropDown from '../../components/dropdown/DropDown';
import {
    getGradeTitle,
    DROPDOWN_ITEMS_LENGTH_EQUAL_ONE,
} from '../../constants/shared/GradesConstants';
import { STUDENT } from '../../constants/shared/CommonConstants';
import NavigationBar from '../navigation/NavigationBar';
import { getDisabledTabIdsForPeriod } from '../../utils/shared/navigationUtils';
import StudentProfile from './studentProfile/StudentProfile';
import StudentListTable from '../studentListTable/StudentListTable';
import './DualLanguage.scss';
import './DualLanguagePrint.scss';

const DualLanguage = ({
    studentsData,
    selectedPeriod,
    selectedGrade,
    grades,
    switchGrade,
    toyTabs,
    currentPeriod,
    switchPeriod,
    isAdditionalResultsFetched,
    isAdditionalEnrollmentInfoFetched,
    fetchAdditionalStudentResults,
    fetchAdditionalEnrollmentData,
    selectStudent,
    downloadStudentActivity,
    sortStudents,
    LinkWrapper,
    licensingInfo,
}) => {
    const firstStudentId = get(head(studentsData), STUDENT.ID);
    const [selectedStudentId, selectStudentId] = useState(firstStudentId);

    useEffect(() => selectStudentId(firstStudentId), [firstStudentId]);

    useEffect(() => {
        if (!isAdditionalEnrollmentInfoFetched) {
            fetchAdditionalEnrollmentData();
        }
    }, []);

    useEffect(() => {
        if (isAdditionalEnrollmentInfoFetched && !isAdditionalResultsFetched) {
            fetchAdditionalStudentResults();
        }
    }, [isAdditionalEnrollmentInfoFetched, isAdditionalResultsFetched]);

    const handleStudentSelect = id => {
        selectStudentId(id);
        selectStudent(id);
    };

    const handleStudentActivityClick = ({ name, id }) => {
        const activityName = name.split(':')[1]?.trim();
        downloadStudentActivity(activityName, id, selectedStudentId);
    };
    return isAdditionalResultsFetched ? (
        <div className="dual-language-container container-wrap">
            <section className="row">
                <aside className="col-md-3 student-list-wrap">
                    <StudentListTable
                        key={`${selectedPeriod}-${selectedGrade}`}
                        studentsData={studentsData}
                        selectedStudentId={selectedStudentId}
                        selectStudentId={handleStudentSelect}
                        onSort={sortStudents}
                    />
                </aside>
                <section className="col-md-9 row flex-column profile-wrap">
                    <div className="tabs-container space-between w-100">
                        <NavigationBar
                            ulTagClassName="nav nav-tabs"
                            tabs={toyTabs}
                            selectedTabId={selectedPeriod}
                            onNavigationTabClick={tabId => switchPeriod(tabId, selectedStudentId)}
                            disabledTabIds={getDisabledTabIdsForPeriod(currentPeriod)}
                            LinkWrapper={LinkWrapper}
                        />
                        <DropDown
                            dropDownClassNames="dl-class-dropdown nav-btn "
                            buttonClassNames="btn-secondary btn-small h-100"
                            dropDownItemClassNames="btn-small"
                            onDropDownItemClick={switchGrade}
                            chosenItem={{
                                uid: selectedGrade,
                                name: getGradeTitle(selectedGrade),
                            }}
                            items={grades.map(grade => ({
                                uid: grade,
                                name: getGradeTitle(grade),
                            }))}
                            isDisabled={grades.length === DROPDOWN_ITEMS_LENGTH_EQUAL_ONE}
                        />
                    </div>
                    <StudentProfile
                        studentData={studentsData.find(
                            studentData => get(studentData, STUDENT.ID) === selectedStudentId,
                        )}
                        licensingInfo={licensingInfo}
                        onActivityClickHandler={handleStudentActivityClick}
                    />
                </section>
            </section>
        </div>
    ) : (
        <Spinner />
    );
};

DualLanguage.defaultProps = {
    studentsData: [],
    selectedPeriod: null,
    selectedGrade: null,
    grades: [],
    toyTabs: [],
    currentPeriod: '',
    isAdditionalResultsFetched: false,
    isAdditionalEnrollmentInfoFetched: false,
    licensingInfo: [],
    switchGrade: () => {},
    switchPeriod: () => {},
    selectStudent: () => {},
    fetchAdditionalStudentResults: () => {},
    fetchAdditionalEnrollmentData: () => {},
    downloadStudentActivity: () => {},
    sortStudents: () => {},
    LinkWrapper: () => {},
};

DualLanguage.propTypes = {
    studentsData: PropTypes.array,
    selectedPeriod: PropTypes.string,
    selectedGrade: PropTypes.string,
    grades: PropTypes.array,
    toyTabs: PropTypes.array,
    currentPeriod: PropTypes.string,
    isAdditionalResultsFetched: PropTypes.bool,
    isAdditionalEnrollmentInfoFetched: PropTypes.bool,
    licensingInfo: PropTypes.arrayOf(PropTypes.string),
    switchGrade: PropTypes.func,
    fetchAdditionalStudentResults: PropTypes.func,
    fetchAdditionalEnrollmentData: PropTypes.func,
    LinkWrapper: PropTypes.func,
    switchPeriod: PropTypes.func,
    selectStudent: PropTypes.func,
    downloadStudentActivity: PropTypes.func,
    sortStudents: PropTypes.func,
};

export default DualLanguage;
